import React from 'react';

const Laying = (props) => (
    <svg viewBox="0 0 500 500" width={34} height={34}>
        <path fill={props.color || '#000'} d="M312.41,233.95h-80.66l-25.37-25.37c-12.14-12.14-31.87-12.14-44.02,0l-47.81,47.81h-7.59c-5.96,0-11.28,2.38-15.07,6.29 c-3.9,3.79-6.29,9.11-6.29,15.07c0,11.82,9.54,21.47,21.36,21.47h205.45c9,0,17.13-3.69,23.09-9.54c5.85-5.96,9.54-14.09,9.54-23.09 C345.04,248.59,330.4,233.95,312.41,233.95z M162.25,256.4l9.97-9.97c6.07-6.07,16.05-6.07,22.12,0l9.97,9.97H162.25z"/>
        <path fill={props.color || '#000'} d="M389.44,234.57L389.44,234.57c-17.85,0-32.33,14.47-32.33,32.33v0c0,17.85,14.47,32.33,32.33,32.33h0 c17.85,0,32.33-14.47,32.33-32.33v0C421.76,249.04,407.29,234.57,389.44,234.57z"/>
    </svg>
);

export default Laying;